"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyContent = void 0;
var React = require("react");
var components_1 = require("components");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var EmptyContent = function (props) {
    var isAccessDenied = function () {
        return props.root.perm === 0x00 && props.section !== 'reliablePartner';
    };
    if (isAccessDenied()) {
        return (React.createElement(components_1.EmptyFolder, { key: 'permission-denied', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-lock' }), title: '', content: '' }));
    }
    return (React.createElement(components_1.EmptyFolder, { key: 'empty-folder', title: (0, translation_1.getLocalization)('bid/tenders/card/no/files/title'), content: (0, translation_1.getLocalization)('bid/tenders/card/no/files/message') }));
};
exports.EmptyContent = EmptyContent;
